var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "item-card",
      staticStyle: {
        "border-radius": "4px !important",
        border: "1px solid #dee5ec",
      },
      attrs: { shadow: "never", "body-style": "margin: 8px;" },
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-row",
          staticStyle: { margin: "8px 8px 8px 8px" },
        },
        [
          _vm.devicePicture && _vm.devicePicture.src
            ? _c("img", {
                staticStyle: { width: "80px", height: "80px" },
                attrs: {
                  alt: _vm.devicePicture.alt,
                  src: _vm.devicePicture.src,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1", staticStyle: { margin: "7px" } }, [
            _c("div", { staticClass: "flex flex-row" }, [
              _c(
                "div",
                {
                  staticClass: "item-name flex-1",
                  staticStyle: { "margin-top": "7px !important" },
                },
                [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
              ),
              _vm._v(" "),
              _vm.quantity > 1
                ? _c(
                    "div",
                    {
                      staticClass: "flex-1",
                      staticStyle: { "margin-top": "8px" },
                    },
                    [
                      _vm._v(
                        "\n          x" + _vm._s(_vm.quantity) + "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-sku" }, [
              _c("strong", [_vm._v("ASIN: ")]),
              _vm._v(" " + _vm._s(_vm.sku) + "\n      "),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }